<template>
  <section class="cards">
    <div class="card">
      <div class="metric">
        <div>
          <div class="metric-label">{{ $t('chi69') }}</div>
          <div class="metric-value">{{ fmt(summary.device_count, 0) }}</div>
          <div class="metric-sub">{{ summary.device_count }} {{ $t('chi70') }} · {{ summary.online_count }} {{ $t('chi71') }}</div>
        </div>
        <div class="icon i-blue">▣</div>
      </div>
    </div>
    <div class="card">
      <div class="metric">
        <div>
          <div class="metric-label">{{ $t('chi73') }}</div>
          <div class="metric-value">{{ fmt(hours, 1) }} {{ $t('chi106') }}</div>
          <div class="metric-sub">{{ $t('chi150') }} · {{ summary.days }} {{ $t('chi156') }}</div>
        </div>
        <div class="icon i-green">◴</div>
      </div>
    </div>
    <div class="card">
      <div class="metric">
        <div>
          <div class="metric-label">{{ $t('chi74') }}</div>
          <div class="metric-value">{{ fmt(summary.avg_daily_runtime / 3600, 1) }} {{ $t('chi106') }}</div>
          <div class="metric-sub">{{ $t('chi75') }}</div>
        </div>
        <div class="icon i-orange">↗</div>
      </div>
    </div>
  </section>
</template>

<script>
import { fmt } from "./statUtils.js";

export default {
  name: "OverviewCards",
  props: {
    // getDeviceBootLog 返回的 summary
    summary: {
      type: Object,
      default: () => ({
        device_count: 0,
        online_count: 0,
        days: 0,
        power_on_count: 0,
        total_runtime: 0,
        avg_daily_runtime: 0,
      }),
    },
  },
  computed: {
    hours() {
      return this.summary.total_runtime / 3600;
    },
  },
  methods: {
    fmt,
  },
};
</script>

<style lang="scss" scoped>
.cards {
  display: grid;
  /* 随容器宽度自适应列数（参照原型，不依赖视口宽度） */
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.card {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  padding: 18px 20px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
}
.metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.metric-label {
  color: #7f93a6;
  font-size: 14px;
}
.metric-value {
  font-size: 30px;
  font-weight: 800;
  margin-top: 8px;
  color: #243a4b;
}
.metric-sub {
  font-size: 12px;
  color: #91a4b4;
  margin-top: 5px;
}
.icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-size: 22px;
  font-weight: 900;
}
.i-blue {
  background: #eaf7ff;
  color: #279ee7;
}
.i-green {
  background: #eafaf3;
  color: #32b97f;
}
.i-orange {
  background: #fff5e6;
  color: #f3a43e;
}
</style>
